import { render, staticRenderFns } from "./UserReportsModal.vue?vue&type=template&id=618402b9"
import script from "./UserReportsModal.vue?vue&type=script&lang=js"
export * from "./UserReportsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports